import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {
  BasicTrialNotificationTemplate
} from "../models/trial-notification-template/basic-trial-notification-template.model";
import {
  AddTrialNotificationTemplate
} from "../models/trial-notification-template/add-trial-notification-template.model";
import {
  UpdateTrialNotificationTemplate
} from "../models/trial-notification-template/update-trial-notification-template.model";
import { environment } from "../../../environments/environment";
import { TrialNotificationTemplate } from "../models/trial-notification-template/trial-notification-template.model";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class TrialNotificationTemplateService {
  private _endpoint = environment.apiUrl + '/TrialNotificationTemplate';

  constructor(private _http: HttpClient) { }

  remove(templateId: string) {
    return this._http.delete<BasicTrialNotificationTemplate[]>(`${this._endpoint}/${templateId}`, {}).pipe(map(rsp => rsp.map(r => new BasicTrialNotificationTemplate(r))));
  }

  disable(templateId: string) {
    return this._http.post(`${this._endpoint}/${templateId}/disable`, {});
  }

  enable(templateId: string) {
    return this._http.post(`${this._endpoint}/${templateId}/enable`, {});
  }

  update(data: UpdateTrialNotificationTemplate) {
    console.log(data);
    return this._http.post<BasicTrialNotificationTemplate[]>(`${this._endpoint}`, data).pipe(map(rsp => rsp.map(r => new BasicTrialNotificationTemplate(r))));
  }

  create(data: AddTrialNotificationTemplate) {
    return this._http.put<BasicTrialNotificationTemplate[]>(`${this._endpoint}`, data).pipe(map(rsp => rsp.map(r => new BasicTrialNotificationTemplate(r))));
  }

  getTemplate(templateId: string) {
    return this._http.get<TrialNotificationTemplate>(`${this._endpoint}/${templateId}`);
  }

  getAllForTrial(trialId: string) {
    return this._http.get<BasicTrialNotificationTemplate[]>(`${this._endpoint}/trial/${trialId}`).pipe(map(rsp => rsp.map(r => new BasicTrialNotificationTemplate(r))));
  }
}
